import settings from '@/settings'

const adicaoDeCredito = (headers, method, data) => {
    // Realiza GET e PUT
    let request = {
        method: method,
        mode: 'cors',
        headers: headers
    }
    if (method === 'GET') request.cache = 'default'
    else request.body = JSON.stringify(data)
    return fetch(`${settings.apetrusApi}/carteiravirtual/adicaodecredito/`, request)
}

const pegarCarteiraVirtualAdm = (headers) => {
    return fetch(`${settings.apetrusApi}/administradores/carteiravirtual/`, {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      headers: headers
    })
}

const pegarCarteiraVirtual = (headers, filtros) => {
    let url = `${settings.apetrusApi}/carteiravirtual/admin/`
    if (filtros) {
        Object.keys(filtros).forEach((filter) => {
            url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${filtros[filter]}`
        })
    }
    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      headers: headers
    })
}

const pegarHistorico = (headers, filtros) => {
    let url = `${settings.apetrusApi}/carteiravirtual/historico/${filtros.id_carteira}/`
    if (filtros) {
        Object.keys(filtros).forEach((filter) => {
            url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${filtros[filter]}`
        })
    }
    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      headers: headers
    })
}

const todas = (headers, data) => {
    let url = `${settings.apetrusApi}/carteiravirtual/todas/`
    if (data) {
      const keys = Object.keys(data)
      for (let i = 0; i < keys.length; i++) {
        url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
      }
    }
    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      headers: headers
    })
  }

export default {
    adicaoDeCredito,
    pegarCarteiraVirtualAdm,
    pegarCarteiraVirtual,
    pegarHistorico,
    todas
}
